import { computed } from 'vue';
import { useRoute } from 'nuxt/app';
import { useProductsStore } from '~~/common/stores/products';

export function useIsReturningFromProductPage () {
  const productsStore = useProductsStore();
  const route = useRoute();
  return computed(() => {
    return productsStore.productListHistoryInformation?.location?.includes(route.fullPath);
  });
}
export function useIsReturningEnabled () {
  const productsStore = useProductsStore();
  return computed(() => {
    return productsStore.productListHistoryInformation?.returnEnabled;
  });
}
